import { ComponentView, ObservableArray } from "binder";
import { TimePart, TimeSelectorViewModel } from "./timeSelector-viewModel"

export class TimeSelectorView extends ComponentView<TimeSelectorViewModel>{
    GetViewUniqueId(): string {
        return "V-3877A95A-AFE1-4FFB-A684-B54679C93221"
    }
    loadHtml(): string {
        let element = require('./timeSelector.html').default;
        let style = require('./timeSelector.less');
        return element;
    }
    constructor() {
       super();
    }
    public set hours(v: ObservableArray<TimePart>) { this._hours = v; } public get hours(): ObservableArray<TimePart> { return this._hours;} private _hours: ObservableArray<TimePart>;
    public set minutes(v: ObservableArray<TimePart>) { this._minutes = v; } public get minutes(): ObservableArray<TimePart> { return this._minutes;} private _minutes: ObservableArray<TimePart>;
    public set selectedHour(v: TimePart) { this._selectedHour = v; } public get selectedHour(): TimePart { return this._selectedHour;} private _selectedHour: TimePart;
    public set selectedMinute(v: TimePart) { this._selectedMinute = v; } public get selectedMinute(): TimePart { return this._selectedMinute;} private _selectedMinute: TimePart;
}
